import { AxiosError } from "axios";

const axiosErrorMessage = ({ error }: { error: AxiosError }) => {
    if (error?.response?.status === 400) {
        var data = error?.response?.data as { message?: string | string[] };
        // class-validator replies with one entry per failed rule.
        if (Array.isArray(data?.message)) {
            return data.message.join(', ');
        }
        return data?.message ?? error?.message;
    } else {
        return error?.message ?? "Error developer";
    }
}

export { axiosErrorMessage };